module.exports = __webpack_public_path__ + "assets/img/ozmo-agencia-en-innovacion.274d9889.png";